import Comuni from '../../misc/comuni.json';
import { ServerConfig } from "../../../../../connectors/Config";


const AddCustomer = {
    SuperAdmin: {
        url: `${ServerConfig.AWS.Serverless.API_BASE_URL_1}/teachers`,
        method: 'POST',
        type: 'form',
        title: 'Aggiungi richiesta',
        grouped: false,
        fields: {
            "Nome e cognome": {
                type: 'string',
                length: 255,
                regex: null,
                group: "Anagrafica",
                fieldName: "name"
            },
            "Qualifica": {
                type: 'string',
                length: 255,
                regex: null,
                group: "Anagrafica",
                fieldName: "qualifica"
            },
            "Data di nascita": {
                type: 'string',
                length: 255,
                regex: null,
                group: "Anagrafica",
                fieldName: "data_di_nascita"
            },
            "Luogo di nascita": {
                type: 'string',
                length: 255,
                regex: null,
                group: "Anagrafica",
                fieldName: "luogo_di_nascita"
            },
            "Codice fiscale": {
                type: 'string',
                length: 255,
                regex: null,
                group: "Anagrafica",
                fieldName: "codice_fiscale"
            },
            "Indirizzo residenza": {
                type: 'string',
                length: 255,
                regex: null,
                group: "Anagrafica",
                fieldName: "indirizzo_residenza"
            },
            "Numero telefono istruttore": {
                type: 'string',
                length: 255,
                regex: null,
                group: "Anagrafica",
                fieldName: "numero_telefono_istruttore"
            },
            "Email personale": {
                type: 'string',
                length: 255,
                regex: null,
                group: "Anagrafica",
                fieldName: "email_personale"
            },
            "Posizione attuale": {
                type: 'string',
                length: 255,
                regex: null,
                group: "Anagrafica",
                fieldName: "posizione_attuale"
            },
            "Numero anni esperienza": {
                type: 'string',
                length: 255,
                regex: null,
                group: "Anagrafica",
                fieldName: "numero_anni_esperienza"
            },
            "Competenze specifiche": {
                type: 'string',
                length: 255,
                regex: null,
                group: "Anagrafica",
                fieldName: "competenze_specifiche"
            },
            "Tipologie corsi per accreditamento": {
                type: 'string',
                length: 255,
                regex: null,
                group: "Anagrafica",
                fieldName: "tipologie_corsi_per_accreditamento"
            },
            "Titolo studio": {
                type: 'string',
                length: 255,
                regex: null,
                group: "Anagrafica",
                fieldName: "titolo_studio"
            },
            "Certificati": {
                type: 'string',
                length: 255,
                regex: null,
                group: "Anagrafica",
                fieldName: "certificati"
            },
            "Corsi insegnati": {
                type: 'string',
                length: 255,
                regex: null,
                group: "Anagrafica",
                fieldName: "corsi_insegnati"
            },
            "Curriculum file": {
                type: 'file-upload-s3',
                fieldName: "curriculum_file"
            },
            "Certificazioni file": {
                type: 'file-upload-s3',
                fieldName: "certificazioni_file"
            },
            "Cover letter file": {
                type: 'file-upload-s3',
                fieldName: "cover_letter_file"
            },
            "Carta d'Identità file": {
                type: 'file-upload-s3',
                fieldName: "identita_file"
            }
        }
    },
    Agent: {
        url: 'http://localhost:4040/api/v1/users',
        method: 'POST',
        type: 'form',
        title: 'Aggiungi richiesta',
        fields: {
                Nome: {
                    type: 'string',
                    length: 255,
                    regex: null,
                    group: "Anagrafica"
                },
                Cognome: {
                    type: 'string',
                    length: 255,
                    regex: null,
                    group: "Anagrafica"
                },
                "Indirizzo": {
                    type: 'string',
                    length: 255,
                    regex: null,
                    group: "Anagrafica"
                },
                Civico: {
                    type: 'string',
                    length: 255,
                    regex: null,
                    group: "Anagrafica"
                },
                Comune: {
                    type: 'autocomplete',
                    length: 255,
                    choices: Comuni,
                    group: "Anagrafica"
                },
                "Codice Fiscale": {
                    type: 'string',
                    length: 255,
                    regex: "^[a-zA-Z]{6}[0-9]{2}[abcdehlmprstABCDEHLMPRST]{1}[0-9]{2}([a-zA-Z]{1}[0-9]{3})[a-zA-Z]{1}$",
                    group: "Anagrafica"
                },
                "Tipo Contratto": {
                    type: 'enum',
                    choices: ["Standard", "Voltura", "Subentro", "Cambio Offerta GAS"],
                    group: "Contratto"
                },
                "Stato Richiesta": {
                    type: 'enum',
                    choices: ["Inserita", "Firmata", "Inoltrata", "Cessata"],
                    group: "Contratto"
                },
                "Tipo cessazione": {
                    type: 'string',
                    length: 255,
                    regex: null,
                    group: "Contratto"
                },
                "Data cessazione": {
                    type: 'date',
                    format: 'DD/MM/YYYY',
                    group: "Contratto"
                },
                
                "Tipo richiesta": {
                    type: 'enum',
                    choices: ["N/A", "Domestico", "Altri usi"],
                    group: "Contratto"
                },
                "Codice Offerta": {
                    type: 'string',
                    length: 255,
                    regex: null,
                    group: "Contratto"
                },
                "Consumo annuo stimato (kWh)": {
                    type: 'number',
                    length: 7,
                    group: "Contratto"
                },
                "Contatto adesione stop carta": {
                    type: 'string',
                    length: 255,
                    regex: null,
                    group: "Contratto"
                },
                "Consumo annuo stimato (mc)": {
                    type: 'number',
                    length: 7,
                    group: "Contratto"
                },
                "Tipo Pagamento": {
                    type: 'enum',
                    choices: ["Domiciliazione", "Bollettino Postale"],
                    group: "Contratto"
                },
                "Codice socio dell'Impresa": {
                    type: 'string',
                    length: 255,
                    regex: null
                },
                "Luogo conclusione contratto": {
                    type: 'string',
                    length: 255,
                    regex: null,
                    group: "Contratto"
                },
                "POD": {
                    type: 'string',
                    length: 255,
                    regex: null,
                    group: "Contratto"
                },
                "PDR": {
                    type: 'string',
                    length: 255,
                    regex: null,
                    group: "Contratto"
                },
        },
        ACL: ['only-mine']
    }
}

export default AddCustomer;